import { PrismLogo } from "@/components/brand/PrismLogo";
import { cn } from "@/lib/cn";

interface WorkspaceBrandProps {
  collapsed?: boolean;
}

/**
 * WorkspaceBrand — Sidebar top'ida PrismOS brand (Decopool workspace).
 * SaaS workspace switcher emas — bitta kompaniya uchun.
 *
 * Faqat vizual qatlam: hover-swap (logo ↔ panel toggle) header cell ichida
 * Sidebar tomonidan boshqariladi. Bu komponent fokus/klik tutmaydi.
 */
export function WorkspaceBrand({ collapsed = false }: WorkspaceBrandProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-2.5",
        // Yig'ilgan rail — 40px markazlangan blok (nav ikonkalari bilan bir o'qda)
        collapsed ? "mx-auto h-10 w-10 justify-center" : "min-w-0",
      )}
      aria-hidden
    >
      {collapsed ? (
        // Yig'ilgan rail — faqat logo mark
        <PrismLogo size={28} />
      ) : (
        // Ochiq holat — logo ikonka + wordmark + workspace nomi
        <>
          <PrismLogo size={30} />
          <div className="flex min-w-0 flex-col leading-tight">
            <span className="font-display text-xl font-semibold tracking-tight text-[var(--text-primary)]">
              Prism<span className="text-gradient">OS</span>
            </span>
            <span className="text-sm text-[var(--text-secondary)]">
              Decopool
            </span>
          </div>
        </>
      )}
    </div>
  );
}
